<template>
  <div>
    <div v-html="$t('connections_description')"></div>
    <div class="row">
      <div class="col-md-12" v-for="(connection,idx) in connections" :key="idx">
        <div
          class="alert alert-danger"
          v-if="!isMinTransferTime(idx)"
        ><p>Planując podróż kilkoma pociągami, załóż na przesiadkę przynajmniej 30 minut, co umożliwi personelowi kolejowemu na danym dworcu zapewnienie pomocy w jego obrębie, w tym podczas przejścia pomiędzy peronami.</p></div>

        <fieldset class="well">
          <legend>
            <span v-if="connection.station_from">
              <span class="sr-only">Połączenie</span>
              {{idx + 1}}. {{connection.station_from}} - {{connection.station_to}}
            </span>
            <span v-if="!connection.station_from">Odcinek {{idx + 1}}</span>
            <span style="font-size: 0.7em">
              (Jeżeli
              <strong>podróż jest z przesiadką</strong> należy uzupełnić każdy odcinek oddzielnie)
            </span>
            <button
              class="btn btn-danger pull-right"
              @click.prevent="removeConnection(idx)"
              v-if="idx > 0"
            >
              <i class="glyphicon glyphicon-remove"></i>
              <span
                class="sr-only"
              >Usuń połączenie {{connection.station_from}} - {{connection.station_to}}</span>
            </button>
          </legend>

          <div class="row">
            <div class="col-sm-6">
              <ic-form-row
                label="Stacja początkowa"
                aria="Pole jest wymagane"
                :new_id="'station_from' + idx"
                :error="hasError('form.connections['+idx+'].station_from')"
                :required="isRequired('form.connections['+idx+'].station_from')"
              >
                <ic-station-typeahead
                  :id="'station_from' + idx"
                  v-model="connection.station_from"
                  valueField="n"
                  :v="v.form.connections.$each[idx].station_from"
                  :noMeta="1"
                  :icStation="-1"
                ></ic-station-typeahead>
              </ic-form-row>
            </div>
            <div class="col-sm-3 col-xs-6 form-padding-left">
              <ic-form-row
                aria="W formacie RRRR-MM-DD. Pole jest wymagane"
                label="Data wyjazdu"
                :new_id="'departure_date' + idx"
                :error="hasError('form.connections[' + idx + '].departure_date')"
                :required="isRequired('form.connections['+idx+'].departure_date')"
              >
                <ic-date-picker
                  :id="'departure_date' + idx"
                  v-model="connection.departure_date"
                  :v="v.form.connections.$each[idx].departure_date"
                  :endDate="maxDate"                 
                ></ic-date-picker>
              </ic-form-row>
            </div>
            <div class="col-sm-3 col-xs-6 form-padding-left">
              <ic-form-row
                aria="W formacie GG:MM. Pole jest wymagane"
                label="Godzina wyjazdu"
                :new_id="'departure_time' + idx"
                :error="hasError('form.connections[' + idx + '].departure_time')"
                :required="isRequired('form.connections['+idx+'].departure_time')"
              >
                <ic-time-picker
                  :id="'departure_time' + idx"
                  v-model="connection.departure_time"
                  :v="v.form.connections.$each[idx].departure_time"
                ></ic-time-picker>
              </ic-form-row>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <!-- Stacja końcowa -->
              <ic-form-row
                aria="Pole jest wymagane"
                label="Stacja końcowa"
                :new_id="'station_to' + idx"
                :error="hasError('form.connections[' + idx + '].station_to')"
                :required="isRequired('form.connections['+idx+'].station_to')"
              >
                <ic-station-typeahead
                  :id="'station_to' + idx"
                  v-model="connection.station_to"
                  valueField="n"
                  :v="v.form.connections.$each[idx].station_to"
                  :noMeta="1"
                  :icStation="-1"
                ></ic-station-typeahead>
              </ic-form-row>
            </div>
            <div class="col-sm-3 col-xs-6 form-padding-left">
              <ic-form-row
                aria="W formacie RRRR-MM-DD. Pole jest wymagane"
                label="Data przyjazdu"
                :new_id="'arrival_date' + idx"
                :error="hasError('form.connections[' + idx + '].arrival_date')"
                :required="isRequired('form.connections['+idx+'].arrival_date')"
              >
                <ic-date-picker
                  :id="'arrival_date' + idx"
                  v-model="connection.arrival_date"
                  :v="v.form.connections.$each[idx].arrival_date"
                  :endDate="maxDate"                 
                ></ic-date-picker>
              </ic-form-row>
            </div>
            <div class="col-sm-3 col-xs-6 form-padding-left">
              <ic-form-row
                aria="W formacie GG:MM. Pole jest wymagane"
                label="Godzina przyjazdu"
                :new_id="'arrival_time' + idx"
                :error="hasError('form.connections[' + idx + '].arrival_time')"
                :required="isRequired('form.connections['+idx+'].arrival_time')"
              >
                <ic-time-picker
                  :id="'arrival_time' + idx"
                  v-model="connection.arrival_time"
                  :v="v.form.connections.$each[idx].arrival_time"
                ></ic-time-picker>
              </ic-form-row>
            </div>
          </div>

          <!-- Przewoźnik -->
          <div class="row">
            <div class="col-sm-6">
              <ic-form-row
                aria="Pole jest wymagane"
                label="Przewoźnik"
                :new_id="'carrier' + idx"
                :error="hasError('form.connections[' + idx + '].carrier')"
                :required="isRequired('form.connections['+idx+'].carrier')"
              >
                <ic-select-system
                  :id="'carrier' + idx"
                  v-model="connection.carrier"
                  :values="carrierTypes"
                  :v="v.form.connections.$each[idx].carrier"
                  :placeholder="'... (wybierz jedną z '+carrierTypes.length+' opcji)'"
                ></ic-select-system>
              </ic-form-row>
            </div>
            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-4 col-xs-4 form-padding-left">
                  <ic-form-row
                    aria="Pole jest wymagane"
                    label="Numer pociągu"
                    :new_id="'train_no' + idx"
                    :error="hasError('form.connections[' + idx + '].train_no')"
                    :required="isRequired('form.connections['+idx+'].train_no')"
                  >
                    <ic-input
                      :id="'train_no' + idx"
                      
                      v-model="connection.train_no"
                      :v="v.form.connections.$each[idx].train_no"
                    ></ic-input>
                  </ic-form-row>
                </div>
                <div class="col-sm-4 col-xs-4 form-padding-left">
                  <ic-form-row
                    label="Numer wagonu"
                    :new_id="'car_no' + idx"
                    :error="hasError('form.connections[' + idx + '].car_no')"
                    :required="isRequired('form.connections['+idx+'].car_no')"
                  >
                    <ic-input
                      :id="'car_no' + idx"
                      v-model="connection.car_no"
                      :v="v.form.connections.$each[idx].car_no"
                      type="number"
                    ></ic-input>
                  </ic-form-row>
                </div>
                <div class="col-sm-4 col-xs-4 form-padding-left">
                  <ic-form-row
                    label="Numer miejsca"
                    :new_id="'seat_no' + idx"
                    :error="hasError('form.connections[' + idx + '].seat_no')"
                    :required="isRequired('form.connections['+idx+'].seat_no')"
                  >
                    <ic-input
                      :id="'seat_no' + idx"
                      v-model="connection.seat_no"
                      :v="v.form.connections.$each[idx].seat_no"
                      type="number"
                    ></ic-input>
                  </ic-form-row>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <button
      class="btn btn-toggle btn-block"
      @click.prevent="addConnection"
      v-if="this.connections.length < 6"
    >Dodaj odcinek przejazdu innym pociągiem lub podróż powrotną.</button>
  </div>
</template>

<script>
import IcDatePicker from "@/components/ic-common/form/controls/DatePicker.vue";
import IcTimePicker from "@/components/ic-common/form/controls/TimePicker.vue";

import IcFormRow from "@/components/ic-common/form/helpers/FormRow.vue";
import IcStationTypeahead from "@/components/ic-common/form/controls/StationTypeAhead.vue";
import IcSelect from "@/components/ic-common/form/controls/Select.vue";
import IcSelectSystem from "@/components/ic-common/form/controls/SelectControl.vue";
import IcInput from "@/components/ic-common/form/controls/Input.vue";
import { carrierTypes } from "./storage";
import moment from "moment";

export default {
  name: "IcFormOznConnection",

  props: {
    value: {
      type: Array
    },
    v: {
      type: Object
    },
    hasError: {
      type: Function,
      required: true
    },
    isRequired: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      maxDate: moment().add(1, 'month').format('YYYY-MM-DD')+'',
      connections: this.value,
      carrierTypes: carrierTypes
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.connections = this.value;
      }
    }
  },
  mounted() {
    if (this.connections.length === 0) {
      this.addItem();
    }
  },
  methods: {
    isMinTransferTime(idx) {
      if (idx > 0) {
        let arrival = moment(
          [
            this.connections[idx - 1].arrival_date,
            this.connections[idx - 1].arrival_time
          ].join(" ")
        );
        let departure = moment(
          [
            this.connections[idx].departure_date,
            this.connections[idx].departure_time
          ].join(" ")
        );
        return arrival.add(29, "minutes").isBefore(departure);
      }
      return true;
    },
    addConnection() {
      if (this.connections.length < 6) {
        if (this.connections.length > 0) {
          let previous = this.connections[this.connections.length - 1];
          let departure = moment(
            [previous.arrival_date, previous.arrival_time].join(" ")
          ).add(30, "minutes");
          let current = {};
          if (departure.isValid()) {
            current = {
              carrier: previous.carrier,
              station_from: previous.station_to,
              departure_date: departure.format("YYYY-MM-DD"),
              departure_time: departure.format("HH:mm"),
              arrival_date: departure.format("YYYY-MM-DD")
            };
          } else {
            current = {
              carrier: previous.carrier,
              station_from: previous.station_to
            };
          }
          this.addItem(current);
        } else {
          this.addItem();
        }
      }
    },
    removeConnection(idx) {
      this.connections.splice(idx, 1);
    },
    addItem(data) {
      let values = Object.assign(
        {
          carrier: "",
          train_no: "",
          car_no: "",
          seat_no: "",
          station_from: "",
          // station_from_name: '',
          departure_date: "",
          departure_time: "",
          station_to: "",
          // station_to_name: '',
          arrival_date: "",
          arrival_time: ""
        },
        data
      );
      this.connections.push(values);
    }
  },
  components: {
    IcDatePicker,
    IcTimePicker,
    IcFormRow,
    IcStationTypeahead,
    IcSelect,
    IcSelectSystem,
    IcInput
  }
};
</script>

<style>
</style>
